import { render, staticRenderFns } from "./GeneralGrid.vue?vue&type=template&id=326125bc&scoped=true&"
import script from "./GeneralGrid.vue?vue&type=script&lang=js&"
export * from "./GeneralGrid.vue?vue&type=script&lang=js&"
import style0 from "./GeneralGrid.vue?vue&type=style&index=0&id=326125bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326125bc",
  null
  
)

export default component.exports